/**
 * SettingKey member NAME for whether customer names are captured as structured given-name/surname
 * fields. Read from the branch-scoped settings map in {@link ApplicationContextStore} as a
 * 'true'/'false' string.
 */
export const STRUCTURED_CUSTOMER_NAME_SETTING_KEY = 'StructuredCustomerName';
